:host {
  display: contents;
}

:host(.rtl-direction) > .drag-info {
  --rtl-offset: -100%;
}

// - - - - - - - - - - - - - - - -
//            Drag info
// - - - - - - - - - - - - - - - -
.drag-info {
  --rtl-offset: 16px;

  position: fixed;
  left: 0; // Necessary since the custom vars are physical values
  top: 0; // Necessary since the custom vars are physical values
  transform: translate(
    calc(var(--ch-tree-view-dragging-item-x) + var(--rtl-offset)),
    calc(var(--ch-tree-view-dragging-item-y) + 8px)
  );
  pointer-events: none;
  z-index: 1; // Necessary to show the element above the expandable buttons
  animation: fade-in 10ms;
}

// Remove mouse actions when processing the drop of items
// @todo: Remove keyboard actions
.waiting-drop-processing {
  cursor: wait;

  ::slotted(*) {
    pointer-events: none;
  }
}

// Wait until the custom var values are updated to avoid flickering
@keyframes fade-in {
  0%,
  100% {
    opacity: 0;
  }
}
